/**
 * 시딩 신청/수락 POST 가 "등록된 SNS 채널 중 콘텐츠 등록 가능 채널이 없음" 으로 거절될 때 BE 가
 * 내려주는 전용 에러 코드. (QAT-39734, BE 0619)
 *
 * 선제 `SNS_MISSING`(요구 플랫폼 미등록 → 등록하기 CTA)과 의미가 다르다 — 여기선 채널은 있으나
 * 콘텐츠 등록 가능 채널이 없는 경우라 등록 유도가 정답이 아닐 수 있다. BE message 를 본문으로 쓰는
 * 단일 확인 다이얼로그(RecruitApplyValidationDialog SNS_INELIGIBLE)로 안내한다.
 */
export const ERROR_CODE_SEEDING_NO_ELIGIBLE_SNS = 'SEEDING-001-011';

/**
 * non-2xx 평문 객체 reject 의 body 를 표준/문자열 형태 모두 지원해 파싱한다.
 * ([[isSeedingProductSoldOutError]] 와 동일 — responseType:'text' / 비표준 body 대비.)
 */
const parseErrorData = (error: unknown): Record<string, unknown> | undefined => {
  if (typeof error !== 'object' || error === null || !('data' in error)) return undefined;
  let data: unknown = (error as { data?: unknown }).data;
  if (typeof data === 'string') {
    try {
      data = JSON.parse(data);
    } catch {
      return undefined;
    }
  }
  if (typeof data !== 'object' || data === null) return undefined;
  return data as Record<string, unknown>;
};

const readString = (value: unknown): string | undefined =>
  typeof value === 'string' && value ? value : undefined;

/** 신청/수락 응답이 "콘텐츠 등록 가능 SNS 채널 없음(SEEDING-001-011)" 인지 판정한다. */
export const isSeedingNoEligibleSnsError = (error: unknown): boolean => {
  const data = parseErrorData(error);
  if (!data) return false;
  const meta = data.meta as { errorCode?: unknown } | undefined;
  return readString(meta?.errorCode) === ERROR_CODE_SEEDING_NO_ELIGIBLE_SNS;
};

/** 안내 다이얼로그 본문에 그대로 쓸 BE 응답 message. 없으면 undefined → 호출부 fallback. */
export const readSeedingNoEligibleSnsMessage = (error: unknown): string | undefined => {
  const data = parseErrorData(error);
  if (!data) return undefined;
  const meta = data.meta as { message?: unknown } | undefined;
  return readString(data.message) ?? readString(meta?.message);
};
